import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
import { Download, Calendar, Filter } from 'lucide-react';
const barData = [{
  name: 'Jan',
  published: 4000,
  rejected: 240
}, {
  name: 'Feb',
  published: 3000,
  rejected: 139
}, {
  name: 'Mar',
  published: 2000,
  rejected: 980
}, {
  name: 'Apr',
  published: 2780,
  rejected: 390
}, {
  name: 'May',
  published: 1890,
  rejected: 480
}, {
  name: 'Jun',
  published: 2390,
  rejected: 380
}, {
  name: 'Jul',
  published: 3490,
  rejected: 430
}];
const pieData = [{
  name: 'Published',
  value: 65
}, {
  name: 'Processing',
  value: 15
}, {
  name: 'Pending',
  value: 10
}, {
  name: 'Rejected',
  value: 10
}];
const COLORS = ['#0d9488', '#3b82f6', '#f59e0b', '#ef4444'];
export const ReportsPage: React.FC = () => {
  return <div className="max-w-7xl mx-auto" data-id="element-549">
      <div className="flex justify-between items-end mb-6" data-id="element-550">
        <div data-id="element-551">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-552">
            Analytics & Reports
          </h1>
          <p className="text-slate-500" data-id="element-553">
            System-wide statistics and data exports
          </p>
        </div>
        <div className="flex space-x-3" data-id="element-554">
          <button className="btn-secondary flex items-center text-sm" data-id="element-555">
            <Filter size={16} className="mr-2" data-id="element-556" /> Filter
          </button>
          <button className="btn-primary flex items-center text-sm" data-id="element-557">
            <Download size={16} className="mr-2" data-id="element-558" /> Export Report
          </button>
        </div>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8" data-id="element-559">
        <div className="card p-5 border-t-4 border-t-teal-500" data-id="element-560">
          <p className="text-sm font-medium text-slate-500 mb-1" data-id="element-561">
            Total Published
          </p>
          <p className="text-3xl font-bold text-slate-900" data-id="element-562">1.2M</p>
          <p className="text-xs text-teal-600 mt-2 flex items-center" data-id="element-563">
            ↑ 12% from last month
          </p>
        </div>
        <div className="card p-5 border-t-4 border-t-blue-500" data-id="element-564">
          <p className="text-sm font-medium text-slate-500 mb-1" data-id="element-565">
            In Processing
          </p>
          <p className="text-3xl font-bold text-slate-900" data-id="element-566">45,230</p>
          <p className="text-xs text-slate-500 mt-2" data-id="element-567">Across 12 districts</p>
        </div>
        <div className="card p-5 border-t-4 border-t-amber-500" data-id="element-568">
          <p className="text-sm font-medium text-slate-500 mb-1" data-id="element-569">
            Pending Validation
          </p>
          <p className="text-3xl font-bold text-slate-900" data-id="element-570">12,400</p>
          <p className="text-xs text-amber-600 mt-2" data-id="element-571">Requires officer review</p>
        </div>
        <div className="card p-5 border-t-4 border-t-red-500" data-id="element-572">
          <p className="text-sm font-medium text-slate-500 mb-1" data-id="element-573">
            Rejection Rate
          </p>
          <p className="text-3xl font-bold text-slate-900" data-id="element-574">4.2%</p>
          <p className="text-xs text-slate-500 mt-2" data-id="element-575">Average this year</p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-576">
        {/* Bar Chart */}
        <div className="card p-6 lg:col-span-2" data-id="element-577">
          <div className="flex justify-between items-center mb-6" data-id="element-578">
            <h2 className="font-semibold text-slate-800" data-id="element-579">
              Publishing Trends (2023)
            </h2>
            <select className="input-field py-1 text-sm w-32" data-id="element-580">
              <option data-id="element-581">This Year</option>
              <option data-id="element-582">Last Year</option>
            </select>
          </div>
          <div className="h-80" data-id="element-583">
            <ResponsiveContainer width="100%" height="100%" data-id="element-584">
              <BarChart data={barData} margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5
            }} data-id="element-585">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e2e8f0" data-id="element-586" />
                <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
                fill: '#64748b'
              }} data-id="element-587" />
                <YAxis axisLine={false} tickLine={false} tick={{
                fill: '#64748b'
              }} data-id="element-588" />
                <Tooltip cursor={{
                fill: '#f1f5f9'
              }} contentStyle={{
                borderRadius: '8px',
                border: 'none',
                boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
              }} data-id="element-589" />
                <Legend data-id="element-590" />
                <Bar dataKey="published" name="Published" fill="#0d9488" radius={[4, 4, 0, 0]} data-id="element-591" />
                <Bar dataKey="rejected" name="Rejected" fill="#ef4444" radius={[4, 4, 0, 0]} data-id="element-592" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Pie Chart */}
        <div className="card p-6" data-id="element-593">
          <h2 className="font-semibold text-slate-800 mb-6" data-id="element-594">
            Current Status Distribution
          </h2>
          <div className="h-64" data-id="element-595">
            <ResponsiveContainer width="100%" height="100%" data-id="element-596">
              <PieChart data-id="element-597">
                <Pie data={pieData} cx="50%" cy="50%" innerRadius={60} outerRadius={80} paddingAngle={5} dataKey="value" data-id="element-598">
                  {pieData.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} data-id="element-599" />)}
                </Pie>
                <Tooltip contentStyle={{
                borderRadius: '8px',
                border: 'none',
                boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
              }} data-id="element-600" />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div className="mt-4 space-y-2" data-id="element-601">
            {pieData.map((entry, index) => <div key={index} className="flex items-center justify-between text-sm" data-id="element-602">
                <div className="flex items-center" data-id="element-603">
                  <div className="w-3 h-3 rounded-full mr-2" style={{
                backgroundColor: COLORS[index]
              }} data-id="element-604"></div>
                  <span className="text-slate-600" data-id="element-605">{entry.name}</span>
                </div>
                <span className="font-medium text-slate-900" data-id="element-606">
                  {entry.value}%
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
};